import axios from 'axios'
const URL = process.env.REACT_APP_RAVEN_URL

export const getCountriesAction = () => async (dispatch) => {
  try {
    const res = await axios({
      method: 'get',
      url: `${URL}/api/v1/config/country-master`,
    })

    return res.data
  } catch (error) {
    console.log('Error')
    console.log(error)
    return error.data
  }
}
